import "./about.css"
const About=()=>{
    return(
        <>
                <div className="about_me" id="about">
                    <div className="right_about">
                        <h1 className="about_heading">ABOUT ME</h1>
                        <p className="about-me-para">Full Stack Web Developer skilled in designing, developing, and deploying scalable web applications. Proficient in front-end technologies like HTML, CSS, JavaScript, and ReactJS, and back-end development using Node.js, Express, and MongoDB. Adept at building responsive UIs, integrating APIs, and optimizing application performance. Passionate about learning emerging technologies and delivering impactful, user-focused solutions. Seeking to contribute technical expertise and problem-solving skills to drive product innovation and growth.</p>
                    </div>
                    <div className="left_about">
                        <img src="https://jaynikatandel.vercel.app/static/media/purpleTheme-girl.56852c94.svg" />
                    </div>
                </div>
            </>
    )
}

export default About